import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactNode } from "react";
import { Spinner } from "../external/ensolvers-core-frontend-mui/components/Common/Spinner";
import { ButtonComponent } from "./ButtonComponent";
import { Token } from "../theme";

interface ButtonLabel {
  label: string;
  onClick: () => void;
}

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  content: ReactNode;
  buttons?: ButtonLabel[];
  hideCancel?: boolean;
  isLoading?: boolean;
  contextLabel?: string;
  consequence?: string;
}

const HEADER = 56;

export const AppEditDrawer = ({
  open,
  onClose,
  title,
  content,
  buttons,
  hideCancel = false,
  isLoading,
  contextLabel,
  consequence,
}: Props) => (
  <Drawer anchor="right" open={open} onClose={onClose}>
    <div style={{ display: "flex", flexDirection: "column", height: "100%", maxWidth: "100vw" }}>
      <div
        style={{
          height: HEADER,
          flexShrink: 0,
          padding: "0 16px",
          borderBottom: `1px solid ${Token.borderSubtle}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <span style={{ fontSize: 15, fontWeight: 600, color: Token.textPrimary }}>{title}</span>
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {contextLabel && (
        <div
          style={{
            flexShrink: 0,
            padding: "8px 16px",
            background: Token.surfaceSunken,
            borderBottom: `1px solid ${Token.borderSubtle}`,
            fontSize: 12.5,
            color: Token.textSecondary,
          }}
        >
          {contextLabel}
        </div>
      )}

      <div style={{ flex: 1, overflowY: "auto", padding: 16, minHeight: 0 }}>{isLoading ? <Spinner /> : content}</div>

      <div
        style={{
          minHeight: HEADER,
          flexShrink: 0,
          padding: "0 16px",
          borderTop: `1px solid ${Token.borderSubtle}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <span style={{ fontSize: 12, color: Token.textTertiary }}>{consequence ?? ""}</span>
        <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
          {!hideCancel && <ButtonComponent onClick={onClose} text="Cancel" />}
          {buttons?.map((button, index) => (
            <ButtonComponent
              key={`${button.label}-${index}`}
              debounce
              onClick={button.onClick}
              text={button.label}
              style={{ backgroundColor: Token.actionPrimary, color: Token.textOnAction }}
            />
          ))}
        </div>
      </div>
    </div>
  </Drawer>
);
